import React from 'react';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { csmAgentOverviewEntryPoint } from '@atlassian/jira-help-center-settings-agent-studio/entrypoint.tsx';

export const LazyAgentStudioOverviewPage = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-help-center-settings-agent-studio-overview", jiraSpaEntry: "help-center-settings-agent-studio-overview" */ '@atlassian/jira-help-center-settings-agent-studio/src/ui/overview/AgentOverviewInternals.tsx'
		).then((module) => module.AgentOverview),
	),
);

export const AgentStudioOverviewPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyAgentStudioOverviewPage}
		pageId="help-center-settings-agent-studio-overview"
		shouldShowSpinner
	/>
);

export const csmAgentOverviewPageEntryPoint = createPageEntryPoint({
	main: csmAgentOverviewEntryPoint,
	topNavigationMenuId: MENU_ID.HELP_CENTER_SETTINGS,
});
